module.exports = __webpack_public_path__ + "t.no1.61f6395f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/t.no1.jpg
// module id = /bEA
// module chunks = 0